<template>
  <div>
    <v-tabs v-model="currentView" color="white" :slider-color="$vuetify.theme.primary">
      <v-tab href="#customerrequestquotation" ripple>{{
        $t('จำนวนการส่งขอประเมินจากลูกค้า')
      }}</v-tab>
      <v-tab href="#dealersendquotation" ripple>{{ $t('รายชื่อร้านค้าตามสถานะ') }}</v-tab>
      <!-- <v-tab href="#dealersendquotation" ripple>{{
        $t('รายชื่อร้านค้าที่ส่งใบประเมินราคาให้ลูกค้า')
      }}</v-tab> -->
      <!-- <v-tab href="#orderscompletepayment" ripple>{{ $t('รายชื่อร้านการชำระเงินสำเร็จ') }}</v-tab> -->
      <!-- <v-tab href="#ordersshipping" ripple>{{ $t('รายชื่อร้านจัดส่งสำเร็จ') }}</v-tab> -->
      <v-tab href="#dealerregistersuccess" ripple>{{ $t('รายชื่อร้านที่ลงทะเบียนสำเร็จ') }}</v-tab>
      <v-tab href="#provincedealer" ripple>{{ $t('รายชื่อจังหวัดที่ร้านค้าอยู่') }}</v-tab>
      <v-tab href="#provinceofdealerquotation" ripple>{{
        $t('รายชื่อจังหวัดที่ร้านค้าถูกขอประเมินราคา')
      }}</v-tab>
      <v-tab href="#channeltoquotationdealerdashboard" ripple>{{
        $t('จำนวนและช่องทางในการติดต่อหาร้านค้า')
      }}</v-tab>
      <v-tab href="#ordersummarywithoutshipping" ripple>{{ $t('ยอดขายที่ขายได้') }}</v-tab>
    </v-tabs>
    <div>
      <components :is="currentView"></components>
    </div>
  </div>
</template>

<script>
import customerrequestquotation from './customerrequestquotation.vue'
import dealersendquotation from './dealersendquotation.vue'
import provincedealer from './provincedealer.vue'
import provinceofdealerquotation from './provinceofdealerquotation.vue'
import ordersummarywithoutshipping from './ordersummarywithoutshipping.vue'
import dealerregistersuccess from './dealerregistersuccess.vue'
import channeltoquotationdealerdashboard from './channeltoquotationdealerdashboard.vue'

export default {
  components: {
    customerrequestquotation,
    dealersendquotation,
    provincedealer,
    provinceofdealerquotation,
    ordersummarywithoutshipping,
    dealerregistersuccess,
    channeltoquotationdealerdashboard
  },
  created() {
    let vm = this
    if (vm.$route.query.tab) {
      vm.currentView = vm.$route.query.tab
    } else {
      vm.currentView = 'customerrequestquotation'
    }
  },
  data() {
    return {
      currentView: ''
    }
  },
  methods: {
    updateRoute: function () {
      this.$router.push({
        name: 'template',
        path: '/template',
        query: {
          tab: this.currentView
        }
      })
      //   this.routeValue = JSON.stringify(this.$route.query)
    }
  },
  watch: {
    currentView: function () {
      this.updateRoute()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toa/Dealer/main.vue